import config from "@/config";
import http from "@/utils/request";

export default {
	data:{
		add: {
			url: `${config.MAIN_URL}/api/v1/jwHangar`,
			name: "新增仓库",
			post: async function (params) {
				return await http.post(this.url, params);
			}
		},
		edit: {
			url: `${config.MAIN_URL}/api/v1/jwHangar`,
			name: "编辑仓库",
			put: async function (params) {
				return await http.put(this.url, params);
			}
		},
		list: {
			url: `${config.MAIN_URL}/api/v1/jwHangar`,
			name: "查询当前基地下所有仓库",
			get: async function (params) {
				return await http.get(this.url, params);
			}
		},
		byId: {
			url: `${config.MAIN_URL}/api/v1/jwHangar/byId`,
			name: "根据id查询仓库",
			get: async function (params) {
				return await http.get(this.url,params);
			}
		},
		delete: {
			url: `${config.MAIN_URL}/api/v1/jwHangar`,
			name: "删除仓库",
			delete: async function (params) {
				return await http.delete(this.url+'?id=', params);
			}
		},
	}
}
